import React from 'react';
import { STIcon } from 'components/Brand/Icons/STIcon';
import { StyledButton } from './styles';

const PlayButton = ({ isPlaying, onClick, setIsPlaying, setHasPlayed }) => {
  const handleClick = e => {
    setIsPlaying(!isPlaying);
    setHasPlayed(true);
    onClick && onClick(e);
  };

  return (
    <StyledButton
      className="wistia-video--play-button"
      aria-label="Play/Pause Button"
      onClick={handleClick}
      playButton={!isPlaying}
    >
      <span className="wistia-video--play-icon">
        <STIcon type={isPlaying ? 'icon-pause' : 'icon-play'} />
      </span>
    </StyledButton>
  );
};

export default PlayButton;
